module.exports = __webpack_public_path__ + "img/documentation.ff27d9ee.svg";